import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { searchCompanies, fetchCompanyById } from "../api/pocketbase";

const initialState = {
  companies: [],
  selectedCompanyId: null,
  status: "idle",
  error: null,
  isLoading: false,
  isCollapsed: false,
  selectedCountry : ""
};

// Fetch Companies
export const fetchCompanies = createAsyncThunk(
  "companies/fetchCompanies",
  async (query) => {
    const data = await searchCompanies(query);
    return data;
  }
);

// Update a single company's data after editing
export const updateCompanyData = createAsyncThunk(
  "companies/updateCompanyData",
  async ({ companyId }) => {
    try {
      const updatedCompany = await fetchCompanyById(companyId);
      return { companyId, updatedCompany };
    } catch (error) {
      throw new Error("Failed to update company data");
    }
  }
);

const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setCompanies: (state, action) => {
      state.companies = action.payload;
    },
    selectCompany: (state, action) => {
      state.selectedCompanyId = action.payload;
    },
    setSidebarCollapsed: (state, action) => {
      state.isCollapsed = action.payload; // <-- Reducer to update sidebar state
    },
    setSelectedCountry : (state, action) => {
      state.selectedCountry = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.status = "loading";
        state.isLoading = true;
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.companies = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        state.isLoading = false;
      })
      .addCase(updateCompanyData.fulfilled, (state, action) => {
        const { companyId, updatedCompany } = action.payload;
        state.companies = state.companies.map((company) =>
          company.id === companyId ? updatedCompany : company
        );
      });
  },
});

export const { setCompanies, selectCompany, setSidebarCollapsed, setSelectedCountry } = companySlice.actions;
export default companySlice.reducer;
